export default __webpack_public_path__ + "static/media/buyer_m.4a8caf23.png";